module.exports = __webpack_public_path__ + "static/media/page-header3.d529fd6f.jpg";